export const certificatePdfFontDownloads = [
  {
    handwritingFont: "patrickHandFont",
    fileName: "Vehicle-certificate.pdf",
    linkLabel: "Download",
  },
  {
    handwritingFont: "kalamFont",
    fileName: "Vehicle-certificate.pdf",
    linkLabel: "Download",
  },
  {
    handwritingFont: "caveatFont",
    fileName: "Vehicle-certificate.pdf",
    linkLabel: "Download",
  },
];

// Returns only the download config matching the font selected on the vehicle
// (the `certificateFont` field returned by the /vehicle/:id/files API). Falls
// back to a single randomly picked font when the value is missing or unrecognized.
export const getCertificateFontDownloads = (certificateFont) => {
  const match = certificatePdfFontDownloads.find(
    (cfg) => cfg.handwritingFont === certificateFont
  );
  if (match) return [match];
  const randomIndex = Math.floor(
    Math.random() * certificatePdfFontDownloads.length
  );
  return [certificatePdfFontDownloads[randomIndex]];
};
